import React, { useState, useRef, useCallback } from 'react';
import styled from 'styled-components';
import { FiSearch, FiEdit3, FiChevronRight } from 'react-icons/fi';
import { FaTimes } from 'react-icons/fa';
import BottomTab from '../components/BottomTab';
import { useNavigate } from 'react-router-dom';
import { useNoobookContext } from '../context/NoobookContext';
import { useEffect } from 'react';
import { getAccessToken } from '../react-queries/queries';
import { processApiResponse } from '../common/errorMessage';
import { getBookeventsByHashtag } from '../api/BookeventApi';
import { communityType2text, activityType2text } from '../common/enums';
import MoimDetailPage from './MoimDetailPage';
import { getPopularBookcommunities, findBookcommunityByHashtag, getSearchHashtags, getNewBookcommunities } from '../api/BookcommunityApi';
import MoimCreatePage from './MoimCreatePage';

const PageWrapper = styled.div`
  max-width: 480px;
  margin: 0 auto;
  min-height: 100vh;
  background: #f5f5f5;
`;
const TopSection = styled.div`
  background: #eae8e9;
`;
const Title = styled.div`
  font-size: 22px;
  font-weight: 700;
  color: #3e3e3e;
  margin: 12px 0 0 0;
  padding-left: 16px;
  margin-bottom: 12px;
  padding-bottom: 10px;
`;
const SearchBox = styled.div`
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 12px;
  margin: 0 20px 18px 20px;
  padding: 0 16px;
  height: 48px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
`;
const SearchInput = styled.input`
  border: none;
  outline: none;
  background: transparent;
  font-size: 16px;
  flex: 1;
  margin-left: 10px;
  &::placeholder {
    font-size: 14px;
    color: #bdbdbd;
  }
`;
const TabRow = styled.div`
  display: flex;
  align-items: center;
  margin: 0 0 0 0;
  border-bottom: 1.5px solid #e0e0e0;
  background: #eae8e9;
`;
const Tab = styled.button`
  flex: 1;
  background: none;
  border: none;
  font-size: 17px;
  font-weight: 600;
  color: ${props => props.active ? '#222' : '#bdbdbd'};
  border-bottom: ${props => props.active ? '3px solid #222' : 'none'};
  padding: 14px 0 10px 0;
  cursor: pointer;
`;
const SectionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 20px 10px 20px;
  margin-top: 0;
`;
const SectionTitle = styled.div`
  font-size: 17px;
  font-weight: 400;
  color: #222;
  display: flex;
  align-items: center;
  gap: 6px;
`;
const SectionBtn = styled.button`
  background: none;
  border: none;
  color: #888;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`;
const MoreBtn = styled.button`
  background: none;
  border: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  padding: 0;
  color: #999;
  font-size: 13px;
  line-height: 1;

  &:hover {
    color: #777;
  }
`;
const MoreCircle = styled.span`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #ddd;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;
const MoimList = styled.div`
  margin: 0 20px 0 20px;
`;
const MoimItem = styled.div`
  display: flex;
  gap: 14px;
  margin-bottom: 22px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
`;
const MoimThumb = styled.img`
  width: 120px;
  height: 80px;
  max-width: 120px;
  max-height: 80px;
  min-width: 120px;
  min-height: 80px;
  border-radius: 0;
  object-fit: cover;
  background: #eee;
  flex-shrink: 0;
`;
const MoimInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  overflow: hidden;
`;
const MoimTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
`;
const MoimTitle = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #222;
  margin-bottom: 0;
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
  line-height: 1.4;
`;
const MoimBadge = styled.div`
  background: ${({ children }) => {
    if (typeof children === 'string' && (children.includes('오프라인') || children.includes('온라인'))) return '#acacac';
    if (typeof children === 'string' && children.includes('필사')) return '#d8a024';
    return '#1976d2';
  }};
  color: #fff;
  font-size: 13px;
  border-radius: 4px;
  padding: 2px 4px;
  white-space: nowrap;
  display: inline-block;
  font-weight: 400;
  margin-left: 4px;
`;
const MoimDesc = styled.div`
  font-size: 14px;
  color: #444;
  margin-bottom: 2px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
`;
const MoimSub = styled.div`
  font-size: 13px;
  color: #888;
  margin-bottom: 2px;
`;
const MoimTags = styled.div`
  font-size: 12px;
  color: #7d7d7d;
  margin-top: 2px;
  font-weight: 500;
`;
const ContentSection = styled.div`
  background: #fff;
  padding-bottom: 80px;
`;
const WhiteSpacer = styled.div`
  height: 20px;
  background: #fff;
`;
const GenreTagScroll = styled.div`
  overflow-x: auto;
  white-space: nowrap;
  padding: 0 20px 16px 20px;
  margin-bottom: 4px;
  -webkit-overflow-scrolling: touch;
  
  /* 스크롤바 완전히 숨기기 */
  &::-webkit-scrollbar {
    display: none;
  }
  
  /* Firefox에서 스크롤바 숨기기 */
  scrollbar-width: none;
  
  /* IE에서 스크롤바 숨기기 */
  -ms-overflow-style: none;
`;
const GenreTag = styled.button`
  display: inline-block;
  background: #245cd8;
  color: #fff;
  border: none;
  border-radius: 14px;
  font-size: 13px;
  padding: 5px 14px;
  margin-right: 8px;
  margin-bottom: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s;
  &:active {
    background: #1746a2;
  }
`;

const EditButton = styled.button`
  background: #1976d2;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background: #1565c0;
  }
`;

const EditModal = styled.div`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 480px;
  height: 100vh;
  background: #fff;
  z-index: 1000;
  display: flex;
  flex-direction: column;
`;

const EditModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 16px 20px;
  border-bottom: 1px solid #eee;
  background: #fff;
`;

const EditModalTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #222;
`;

const EditCloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
  
  &:hover {
    background: #f5f5f7;
  }
`;

const EditModalContent = styled.div`
  flex: 1;
  overflow-y: auto;
`;

const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 480px;
  height: 100vh;
  background: #fff;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  
`;

//overflow-y: hidden;


const ModalTest = styled.div`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow-y: hidden;
  z-index: 9999;
  
  /* 모달이 열려있을 때 배경 스크롤 방지 */
  &::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: transparent;
    z-index: -1;
  }
`;



const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 16px 20px;
  border-bottom: 1px solid #eee;
  background: #fff;
`;

const ModalTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #222;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
  
  &:hover {
    background: #f5f5f7;
  }
`;

const ModalContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0 0px 20px 0px;
`;

const LoadingText = styled.div`
  text-align: center;
  padding: 20px;
  color: #888;
  font-size: 14px;
`;
/*
const TESTEvent = () => {
  return (
    <Modal>
    <ModalTitle>TESTEvent</ModalTitle>
    </Modal>
  )
};*/
const CommunityDetailModal = ({ bookCommunityId, onClose }) => {
  const [isModified, setIsModified] = useState(false);

  // 모달이 열려있을 때 배경 스크롤 방지
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  return (
    <Modal >
      <ModalHeader>
        <ModalTitle>모임 상세</ModalTitle>
        <CloseButton onClick={()=>{onClose(isModified);}}>
          <FaTimes />
        </CloseButton>
      </ModalHeader>
      <ModalContent id="noobook-page-modal">
        <MoimDetailPage bookCommunityId={bookCommunityId} onModified={setIsModified}
         onClose={()=>{onClose(true);}} />
      </ModalContent>
    </Modal>
  )
};

// EventListModal을 CommunityListModal로 변경
const CommunityListModal = ({ eventTitle, closeBtnClick, eventList, eventListItemClick, onScroll, modalLoading, hasMoreList }) => {

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  return (
    <Modal>
      <ModalHeader>
        <ModalTitle>{eventTitle}</ModalTitle>
        <CloseButton onClick={closeBtnClick}>
          <FaTimes />
        </CloseButton>
      </ModalHeader>
      <ModalContent onScroll={onScroll}>
        <MoimList>
          {eventList?.map((item, i) => (
            <MoimItem
              key={item.id ?? i}
              onClick={() => eventListItemClick(item.id)}
              style={{ cursor: 'pointer' }}
            >
              <MoimThumb src={item.imgUrl || '/book_sample.jpg'} alt={item.title} />
              <MoimInfo>
                <MoimTitleRow>
                  <MoimTitle>{item.title}</MoimTitle>
                  <MoimBadge>{communityType2text(item.communityType)}</MoimBadge>
                  <MoimBadge>{activityType2text(item.activityType)}</MoimBadge>
                </MoimTitleRow>
                <MoimDesc>{item.briefIntroduction}</MoimDesc>
                <MoimTags>
                  {item.hashtags && item.hashtags.length > 0
                    ? item.hashtags.map(tag => `#${tag}`).join(' ')
                    : '#태그없음'
                  }
                </MoimTags>
              </MoimInfo>
            </MoimItem>
          ))}
          {modalLoading && <LoadingText>로딩 중...</LoadingText>}
          {!hasMoreList && eventList?.length > 0 && (
            <LoadingText>모든 목록을 불러왔습니다.</LoadingText>
          )}
        </MoimList>
      </ModalContent>
    </Modal>
  );
};

const PAGE_SIZE = 20;
const defaultGenreTags = ['#소설', '#인문', '#자기계발', '#과학', '#그림책', '#역사'];


export function CommunityMoimPage() {
  const [tab, setTab] = useState('review');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [deadlineMoimList, setDeadlineMoimList] = useState([]);
  const [newMoimList, setNewMoimList] = useState([]);
  const [loading, setLoading] = useState(false);
  
  // 모달 관련 상태
  const [selectedHashTag, setSelectedHashTag] = useState('');
  const [showPopularMoimModal, setShowPopularMoimModal] = useState(false);
  const [showGenreMoimModal, setShowGenreMoimModal] = useState(false);
  const [showNewMoimModal, setShowNewMoimModal] = useState(false);
  const [modalPopularMoimList, setModalPopularMoimList] = useState([]);
  const [modalGenreMoimList, setModalGenreMoimList] = useState([]);
  const [modalNewMoimList, setModalNewMoimList] = useState([]);
  const [modalLoading, setModalLoading] = useState(false);
  const [hasMorePopularMoim, setHasMorePopularMoim] = useState(true);
  const [hasMoreGenreMoim, setHasMoreGenreMoim] = useState(true);
  const [hasMoreNewMoim, setHasMoreNewMoim] = useState(true);
  const [popularMoimPage, setPopularMoimPage] = useState(0);
  const [genreMoimPage, setGenreMoimPage] = useState(0);
  const [newMoimPage, setNewMoimPage] = useState(0);  
  
  // 이벤트 상세 모달 관련 상태
  const [showCommunityDetailModal, setShowCommunityDetailModal] = useState(false);
  const [selectedBookCommunityId, setSelectedBookCommunityId] = useState(null);
  
  // 인기모임 목록 상태
  const [popularMoimList, setPopularMoimList] = useState([]);

  // 장르별 모임 목록 상태
  const [genreMoimList, setGenreMoimList] = useState([]);
  const [selectedGenreTag, setSelectedGenreTag] = useState('');

  // 해시태그 목록 상태
  const [genreTags, setGenreTags] = useState([]);

  // 신규모임 목록 상태
  const [newRecommendMoimList, setNewRecommendMoimList] = useState([]);

  const [showEditModal, setShowEditModal] = useState(false);

  const [isModified, setIsModified] = useState(true);

  const handleTab = t => setTab(t);
  const navigate = useNavigate();
  const { setShowBack } = useNoobookContext();
  
  // 초기 데이터 설정
  useEffect(() => {
    if(isModified) {
      loadPopularMoimList();
      loadSearchHashtags(); // 컴포넌트 마운트 시 해시태그 목록 로드
      loadGenreMoimList(null);
      loadNewBookcommunities(); // 신규모임 목록 로드 추가
      setIsModified(false);
    }
  }, [isModified]);
  
  

  // 모달에서 마감임박 목록 로드
  const loadModalPopularMoimList = useCallback(async (page = 0, append = false) => {
    if (modalLoading || (!hasMorePopularMoim && page > 0)) return;
    
    setModalLoading(true);
    try {
      const { accessToken } = await getAccessToken();
      
      const response = await getPopularBookcommunities(
        accessToken || '', 
        page, 
        PAGE_SIZE
      );
      const processedResponse = processApiResponse(response);
      
      if (processedResponse.success) {
        const newData = processedResponse.data || [];
        if (append) {
          setModalPopularMoimList(prev => [...prev, ...newData]);
        } else {
          setModalPopularMoimList(newData);
        }
        setHasMorePopularMoim(newData.length === PAGE_SIZE);
        setPopularMoimPage(page);
      } else {
        console.error('마감임박 목록 로드 실패:', processedResponse.errorMessage);
      }
    } catch (error) {
      console.error('마감임박 목록 로드 중 오류:', error);
    } finally {
      setModalLoading(false);
    }
  }, [searchKeyword, modalLoading, hasMorePopularMoim]);

  // 모달에서 신규 서평단 모집 목록 로드
  const loadModalGenreMoimList = useCallback(async (page = 0, append = false) => {
    if (modalLoading || (!hasMoreGenreMoim && page > 0)) return;
    
    setModalLoading(true);
    try {
      const { accessToken } = await getAccessToken();
      const response = await findBookcommunityByHashtag(
        accessToken || '', 
        selectedHashTag || '', 
        null,
        null,
        page, 
        PAGE_SIZE
      );
      const processedResponse = processApiResponse(response);
      
      if (processedResponse.success) {
        const newData = processedResponse.data || [];
        if (append) {
          setModalGenreMoimList(prev => [...prev, ...newData]);
        } else {
          setModalGenreMoimList(newData);
        }
        setHasMoreGenreMoim(newData.length === PAGE_SIZE);
        setGenreMoimPage(page);
      } else {
        console.error('장르별 모임 목록 로드 실패:', processedResponse.errorMessage);
      }
    } catch (error) {
      console.error('장르별 모임 목록 로드 중 오류:', error);
    } finally {
      setModalLoading(false);
    }
  }, [searchKeyword, selectedHashTag, modalLoading, hasMoreGenreMoim]);

  const loadModalNewMoimList = useCallback(async (page = 0, append = false) => {
    if (modalLoading || (!hasMoreNewMoim && page > 0)) return;
    
    setModalLoading(true);
    try {
      const { accessToken } = await getAccessToken();
      const response = await getNewBookcommunities(
        accessToken || '', 
        page, 
        PAGE_SIZE
      );
      const processedResponse = processApiResponse(response);
      
      if (processedResponse.success) {
        const newData = processedResponse.data || [];
        if (append) {
          setModalNewMoimList(prev => [...prev, ...newData]);
        } else {
          setModalNewMoimList(newData);
        }
        setHasMoreNewMoim(newData.length === PAGE_SIZE);
        setNewMoimPage(page);
      } else {
        console.error('신규 모임 목록 로드 실패:', processedResponse.errorMessage);
      }
    } catch (error) {
      console.error('신규 모임 목록 로드 중 오류:', error);
    } finally {
      setModalLoading(false);
    }
  }, [modalLoading, hasMoreNewMoim]);

  // 마감임박 모달 열기
  const openPopularMoimModal = () => {
    setShowPopularMoimModal(true);
    setModalPopularMoimList([]);
    setPopularMoimPage(0);
    setHasMorePopularMoim(true);
    loadModalPopularMoimList(0, false);
  };

  // 장르별 모임 모달 열기
  const openGenreMoimModal = () => {
    setShowGenreMoimModal(true);
    setModalGenreMoimList([]);
    setGenreMoimPage(0);
    setHasMoreGenreMoim(true);
    loadModalGenreMoimList(0, false);
  };

  // 신규모임 모달 열기
  const openNewMoimModal = () => {
    setShowNewMoimModal(true);
    setModalNewMoimList([]);
    setNewMoimPage(0);
    setHasMoreNewMoim(true);
    loadModalNewMoimList(0, false);
  };

  // 모달에서 아이템 클릭 시 상세 모달 열기
  const handleBookCommunityItemClick = useCallback((bookCommunityId) => {
    setSelectedBookCommunityId(bookCommunityId);
    setShowCommunityDetailModal(true);
  }, []);

  // 상세 모달 닫기
  const closeCommunityDetailModal = (modified) => {
    setShowCommunityDetailModal(false);
    setSelectedBookCommunityId(null);
    if(modified) {
      setIsModified(true);
      if(showPopularMoimModal) {
        loadModalPopularMoimList(0, false);
      } else if(showGenreMoimModal) {
        loadModalGenreMoimList(0, false);
      } else if(showNewMoimModal) {
        loadModalNewMoimList(0, false);
      }
    }
  };

  // 무한 스크롤 핸들러
  const handlePopularMoimScroll = useCallback((e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollTop + clientHeight >= scrollHeight - 100 && hasMorePopularMoim && !modalLoading) {
      loadModalPopularMoimList(popularMoimPage + 1, true);
    }
  }, [popularMoimPage, hasMorePopularMoim, modalLoading, loadModalPopularMoimList]);

  const handleGenreMoimScroll = useCallback((e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollTop + clientHeight >= scrollHeight - 100 && hasMoreGenreMoim && !modalLoading) {
      loadModalGenreMoimList(genreMoimPage + 1, true);
    }
  }, [genreMoimPage, hasMoreGenreMoim, modalLoading, loadModalGenreMoimList]);

  const handleNewMoimScroll = useCallback((e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollTop + clientHeight >= scrollHeight - 100 && hasMoreNewMoim && !modalLoading) {
      loadModalNewMoimList(newMoimPage + 1, true);
    }
  }, [newMoimPage, hasMoreNewMoim, modalLoading, loadModalNewMoimList]);


  // 인기모임 목록 로드
  const loadPopularMoimList = async () => {
    try {
      const { accessToken } = await getAccessToken();
      if (!accessToken) return;
      
      const response = await getPopularBookcommunities(accessToken, 0, 5);
      const processedResponse = processApiResponse(response);
      
      if (processedResponse.success) {
        setPopularMoimList(processedResponse.data || []);
      } else {
        console.error('인기모임 목록 로드 실패:', processedResponse.errorMessage);
        setPopularMoimList([]);
      }
    } catch (error) {
      console.error('인기모임 목록 로드 중 오류:', error);
      setPopularMoimList([]);
    }
  };

  // 장르별 모임 목록 로드
  const loadGenreMoimList = async (hashtag) => {
    try {
      const { accessToken } = await getAccessToken();
      if (!accessToken) return;
      
      // 현재 날짜 기준으로 날짜 범위 설정 (예: 오늘부터 1년 후까지)
      const recruitToFr = new Date();
      const recruitToTo = new Date();
      recruitToTo.setFullYear(recruitToTo.getFullYear() + 1);
      
      const response = await findBookcommunityByHashtag(
        accessToken, 
        hashtag, 
        null,
        null,
        0, 
        5
      );
      const processedResponse = processApiResponse(response);
      
      if (processedResponse.success) {
        setGenreMoimList(processedResponse.data || []);
      } else {
        console.error('장르별 모임 목록 로드 실패:', processedResponse.errorMessage);
        setGenreMoimList([]);
      }
    } catch (error) {
      console.error('장르별 모임 목록 로드 중 오류:', error);
      setGenreMoimList([]);
    }
  };

  // GenreTag 클릭 핸들러
  const handleGenreTagClick = (tag) => {
    // # 제거하고 실제 해시태그만 추출
    const hashtag = tag.replace('#', '');
    setSelectedHashTag(hashtag);
    loadGenreMoimList(hashtag);
  };

  // 해시태그 데이터 로딩 함수
  const loadSearchHashtags = async () => {
    try {
      const { accessToken } = await getAccessToken();
      if (!accessToken) return;
      
      const response = await getSearchHashtags(accessToken);
      const processedResponse = processApiResponse(response);
      
      if (processedResponse.success) {
        // API에서 받은 해시태그 배열을 # 접두사와 함께 설정
        const hashtagsWithPrefix = (processedResponse.data || []).map(tag => `#${tag}`);
        setGenreTags(hashtagsWithPrefix);
      } else {
        console.error('해시태그 목록 로드 실패:', processedResponse.errorMessage);
        // 실패 시 기본값 설정
        setGenreTags([]);
      }
    } catch (error) {
      console.error('해시태그 목록 로드 중 오류:', error);
      // 에러 시 기본값 설정
      setGenreTags([]);
    }
  };

  // 신규모임 데이터 로딩 함수
  const loadNewBookcommunities = async () => {
    try {
      const { accessToken } = await getAccessToken();
      if (!accessToken) return;
      
      const response = await getNewBookcommunities(accessToken, 0, 5);
      const processedResponse = processApiResponse(response);
      
      if (processedResponse.success) {
        setNewRecommendMoimList(processedResponse.data || []);
      } else {
        console.error('신규모임 목록 로드 실패:', processedResponse.errorMessage);
        setNewRecommendMoimList([]);
      }
    } catch (error) {
      console.error('신규모임 목록 로드 중 오류:', error);
      setNewRecommendMoimList([]);
    }
  };

  const openEditModal = () => {
    setShowEditModal(true);
  };

  // 수정 모달 닫기
  const closeEditModal = (modified) => {
    setShowEditModal(false);
    if(modified) {
      setIsModified(true);
    }
  };

  // 뒤로가기 버튼으로 모달 닫기
  useEffect(() => {
    const handlePopState = (event) => {
      if (showPopularMoimModal) {
        event.preventDefault();
        setShowPopularMoimModal(false);
        // history를 다시 push하여 뒤로가기 이벤트를 취소
        //window.history.pushState(null, '', window.location.href);
      } else if (showGenreMoimModal) {
        event.preventDefault();
        setShowGenreMoimModal(false);
        // history를 다시 push하여 뒤로가기 이벤트를 취소
        //window.history.pushState(null, '', window.location.href);
      } else if (showNewMoimModal) {
        event.preventDefault();
        setShowNewMoimModal(false);
        // history를 다시 push하여 뒤로가기 이벤트를 취소
        //window.history.pushState(null, '', window.location.href);
      } else if (showCommunityDetailModal) {
        event.preventDefault();
        closeCommunityDetailModal(false);
        // history를 다시 push하여 뒤로가기 이벤트를 취소
       // window.history.pushState(null, '', window.location.href);
      } else if (showEditModal) {
        event.preventDefault();
        closeEditModal(false);
        // history를 다시 push하여 뒤로가기 이벤트를 취소
        //window.history.pushState(null, '', window.location.href);
      }
    };

    // 모달이 열려있을 때만 history state를 push하고 이벤트 리스너 등록
    if (showPopularMoimModal || showGenreMoimModal || showNewMoimModal || showCommunityDetailModal || showEditModal) {
      window.history.pushState(null, '', window.location.href);
      window.addEventListener('popstate', handlePopState);
    }

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [showPopularMoimModal, showGenreMoimModal, showNewMoimModal, showCommunityDetailModal, showEditModal]);
      



  /*
  // 검색어 입력 처리
  const handleSearchInputChange = (e) => {
    setSearchKeyword(e.target.value);
  };

  // 검색어 입력 후 Enter 키 처리
  const handleSearchKeyPress = (e) => {
    if (e.key === 'Enter') {
      searchBookevents();
    }
  };
  */

  return (
    <PageWrapper>
      <ContentSection>
          <>
            <WhiteSpacer />
            <SectionRow>
              <SectionTitle>
                인기모임
                <MoreBtn type="button" onClick={openPopularMoimModal} aria-label="인기모임 더보기">
                  <MoreCircle>
                    <FiChevronRight size={12} />
                  </MoreCircle>
                  더보기
                </MoreBtn>
              </SectionTitle>
              <SectionBtn onClick={()=>/*navigate('/moim-create')*/openEditModal()}><FiEdit3 size={16} /> 모임 만들기</SectionBtn>
            </SectionRow>
            <MoimList>
              {popularMoimList.map((item, i) => (
                <MoimItem key={i} onClick={() => /*navigate(`/moim-detail?id=${item.id}`)*/handleBookCommunityItemClick(item.id)} style={{cursor:'pointer'}}>
                  <MoimThumb src={item.imgUrl || '/book_sample.jpg'} alt={item.title} />
                  <MoimInfo>
                    <MoimTitleRow>
                      <MoimTitle>{item.title}</MoimTitle>
                      <MoimBadge>{communityType2text(item.communityType)}</MoimBadge>
                      <MoimBadge>{activityType2text(item.activityType)}</MoimBadge>
                    </MoimTitleRow>
                    <MoimDesc>{item.briefIntroduction}</MoimDesc>
                    <MoimTags>
                      {item.hashtags && item.hashtags.length > 0 
                        ? item.hashtags.map(tag => `#${tag}`).join(' ')
                        : '#태그없음'
                      }
                    </MoimTags>
                  </MoimInfo>
                </MoimItem>
              ))}
            </MoimList>
            <SectionRow style={{marginTop:32}}>
              <SectionTitle>
                장르별모임
                <MoreBtn type="button" onClick={openGenreMoimModal} aria-label="장르별모임 더보기">
                  <MoreCircle>
                    <FiChevronRight size={12} />
                  </MoreCircle>
                  더보기
                </MoreBtn>
              </SectionTitle>
            </SectionRow>
            <GenreTagScroll>
              {genreTags.map(tag => (
                <GenreTag key={tag} onClick={() => handleGenreTagClick(tag)}>{tag}</GenreTag>
              ))}
            </GenreTagScroll>
            <MoimList>
              {genreMoimList.map((item, i) => (
                <MoimItem key={i} onClick={() => /*navigate(`/moim-detail?id=${item.id}`*/handleBookCommunityItemClick(item.id)} style={{cursor:'pointer'}}>
                  <MoimThumb src={item.imgUrl || '/book_sample.jpg'} alt={item.title} />
                  <MoimInfo>
                    <MoimTitleRow>
                      <MoimTitle>{item.title}</MoimTitle>
                      <MoimBadge>{item.communityType === 'ONLINE' ? '온라인' : '오프라인'}</MoimBadge>
                    </MoimTitleRow>
                    <MoimDesc>{item.briefIntroduction}</MoimDesc>
                    <MoimTags>
                      {item.hashtags && item.hashtags.length > 0 
                        ? item.hashtags.map(tag => `#${tag}`).join(' ')
                        : '#태그없음'
                      }
                    </MoimTags>
                  </MoimInfo>
                </MoimItem>
              ))}
            </MoimList>
            <SectionRow style={{marginTop:32}}>
              <SectionTitle>
                신규모임
                <MoreBtn type="button" onClick={openNewMoimModal} aria-label="신규모임 더보기">
                  <MoreCircle>
                    <FiChevronRight size={12} />
                  </MoreCircle>
                  더보기
                </MoreBtn>
              </SectionTitle>
            </SectionRow>
            <MoimList>
              {newRecommendMoimList.map((item, i) => (
                <MoimItem key={i} onClick={() => /*navigate(`/moim-detail?id=${item.id}`*/handleBookCommunityItemClick(item.id)} style={{cursor:'pointer'}}>
                  <MoimThumb src={item.imgUrl || '/book_sample.jpg'} alt={item.title} />
                  <MoimInfo>
                    <MoimTitleRow>
                      <MoimTitle>{item.title}</MoimTitle>
                      <MoimBadge>{item.communityType === 'ONLINE' ? '온라인' : '오프라인'}</MoimBadge>
                    </MoimTitleRow>
                    <MoimDesc>{item.briefIntroduction}</MoimDesc>
                    <MoimTags>
                      {item.hashtags && item.hashtags.length > 0 
                        ? item.hashtags.map(tag => `#${tag}`).join(' ')
                        : '#태그없음'
                      }
                    </MoimTags>
                  </MoimInfo>
                </MoimItem>
              ))}
            </MoimList>
          </> 
        </ContentSection> 

      {/* 마감임박 모달 */}
      {showPopularMoimModal && (
        <CommunityListModal 
          eventTitle="인기모임" 
          closeBtnClick={() => setShowPopularMoimModal(false)} 
          eventList={modalPopularMoimList} 
          eventListItemClick={handleBookCommunityItemClick} 
          onScroll={handlePopularMoimScroll} 
          modalLoading={modalLoading} 
          hasMoreList={hasMorePopularMoim} 
        />
      )}

      {/* 신규 서평단 모집 모달 */}
      {showGenreMoimModal && (
        <CommunityListModal 
          eventTitle="장르별모임" 
          closeBtnClick={() => setShowGenreMoimModal(false)} 
          eventList={modalGenreMoimList} 
          eventListItemClick={handleBookCommunityItemClick} 
          onScroll={handleGenreMoimScroll} 
          modalLoading={modalLoading} 
          hasMoreList={hasMoreGenreMoim} 
        />
      )}

      {/* 신규 서평단 모집 모달 */}
      {showNewMoimModal && (
        <CommunityListModal 
          eventTitle="신규모임" 
          closeBtnClick={() => setShowNewMoimModal(false)} 
          eventList={modalNewMoimList} 
          eventListItemClick={handleBookCommunityItemClick} 
          onScroll={handleNewMoimScroll} 
          modalLoading={modalLoading} 
          hasMoreList={hasMoreNewMoim} 
        />
      )}


      {/* 이벤트 상세 모달 */}
      {showCommunityDetailModal && (
        <CommunityDetailModal 
          bookCommunityId={selectedBookCommunityId} 
          onClose={closeCommunityDetailModal}
        />
      )}

       {/* 수정 모달 */}
       {showEditModal && (
        <EditModal>
          <EditModalHeader>
            <EditModalTitle>모임 만들기</EditModalTitle>
            <CloseButton onClick={closeEditModal}>
              <FaTimes />
            </CloseButton>
          </EditModalHeader>
          <EditModalContent>
            <MoimCreatePage editBookCommunityId={null} onClose={closeEditModal} />
          </EditModalContent>
        </EditModal>
      )}
     
    </PageWrapper>
  );
}

export default CommunityMoimPage; 